import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpService, UnitOfMeasureEnum, LanguageEnum } from 'src/app/services/http-service';
import { ToolbarComponent } from 'src/app/toolbar/toolbar.component';

export interface ProfileModalData {
  unitOfMeasure: UnitOfMeasureEnum;
  language: LanguageEnum;
}

export interface SettingsModalResult {
  unitOfMeasure: UnitOfMeasureEnum;
  language: LanguageEnum;
}

@Component({
  selector: 'profile-modal',
  templateUrl: 'profile-modal.html',
  styleUrls: ['profile-modal.css'],
})
export class ProfileModal implements OnInit {
  unitOfMeasure: UnitOfMeasureEnum;
  unitOfMeasures = UnitOfMeasureEnum;
  language: LanguageEnum;
  languages = LanguageEnum;

  languageOptions = [
    { value: LanguageEnum.English, label: 'English', flag: '🇬🇧' },
    { value: LanguageEnum.Italian, label: 'Italiano', flag: '🇮🇹' },
    { value: LanguageEnum.German, label: 'Deutsch', flag: '🇩🇪' },
    { value: LanguageEnum.French, label: 'Français', flag: '🇫🇷' },
    { value: LanguageEnum.Spanish, label: 'Español', flag: '🇪🇸' },
    { value: LanguageEnum.Dutch, label: 'Nederlands', flag: '🇳🇱' },
    { value: LanguageEnum.Portuguese, label: 'Português', flag: '🇵🇹' },
    { value: LanguageEnum.Polish, label: 'Polski', flag: '🇵🇱' }
  ];

  constructor(
    public httpService: HttpService,
    public dialogRef: MatDialogRef<ProfileModal>,
    @Inject(DOCUMENT) private document: Document,
    @Inject(MAT_DIALOG_DATA) public data: ProfileModalData
  ) {
    this.unitOfMeasure = data.unitOfMeasure;
    this.language = data.language;
  }

  async ngOnInit() {
  }

  getSelectedLanguageOption() {
    return this.languageOptions.find(lang => lang.value === this.language);
  }

  onSave(): void {
    this.dialogRef.close({
      unitOfMeasure: this.unitOfMeasure,
      language: this.language,
    });
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
